import Reveal from "reveal.js/dist/reveal.esm.js";
import RevealMarkdown from "reveal.js/plugin/markdown/markdown.esm.js";
import RevealZoom from "reveal.js/plugin/zoom/zoom.esm.js";
import RevealNotes from "reveal.js/plugin/notes/notes.esm.js";
import RevealSearch from "reveal.js/plugin/search/search.esm.js";
import RevealHighlight from "reveal.js/plugin/highlight/highlight.esm.js";

window.Reveal = Reveal;
window.RevealMarkdown = RevealMarkdown;
window.RevealNotes = RevealNotes;
window.RevealSearch = RevealSearch;
window.RevealZoom = RevealZoom;
window.RevealHighlight = RevealHighlight;